import { create } from 'zustand';
import Pr from '@/types/prType';
import { PrReqOrg } from '@/types/prReqType';
import { PrReqInd } from '@/types/prReqType';

import {
  fetchPRsForLoggedOutUser,
  fetchPRsForUserInd,
  fetchPRsForUserOrg,
} from '@/apis/fetchPRsForUser';
import headerObject from '@/types/headerObj';
import emptyHeaderObj from '@/types/emptyHeaderObj';
import useUserStore from './userState';
import useOrganizationStore from './orgState';

interface PrState {
  prList: Pr[];
  setPrListOrg: (req: PrReqOrg) => Promise<Pr[]>;
  setPrListInd: (req: PrReqInd) => Promise<Pr[]>;
  setPrListForLoggedOut: (reponame: string) => Promise<Pr[]>;
}
const headerObj: headerObject = emptyHeaderObj;
headerObj.Useruuid = useUserStore.getState().user?.UserUUID;
headerObj.Useremail = useUserStore.getState().user?.Email;
headerObj.Username = useUserStore.getState().user?.FirstName;
headerObj.Orgname = useOrganizationStore.getState().organization?.OrgName;
headerObj.Orguuid = useOrganizationStore.getState().organization?.OrgUUID;

const usePrStore = create<PrState>()((set, get) => ({
  prList: [],
  setPrListOrg: async (req: PrReqOrg) => {
    const prList = await fetchPRsForUserOrg(req, headerObj);
    set({
      prList: await prList,
    });
    return prList;
  },
  setPrListInd: async (req: PrReqInd) => {
    const prList = await fetchPRsForUserInd(req, headerObj);
    set({
      prList: await prList,
    });
    return prList;
  },
  setPrListForLoggedOut: async (reponame: string) => {
    const prList = await fetchPRsForLoggedOutUser(reponame);
    set({
      prList: prList || [],
    });
    return prList || [];
  },
}));

export default usePrStore;
